import React, { useMemo, useState } from "react";
import { Field, useFormState } from "react-final-form";
import { getData } from "country-list";
import BootstrapInput from "../../../../../../../components/BootstrapInput";
import Autocomplete from "../../../../../../../components/Autocomplete";
import { EDUCATION_TYPES } from "../../../../../../school/constants/types";

export default function School() {
  const countries = useMemo(
    () =>
      getData().sort((a, b) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0,
      ),
    [],
  );
  const { values } = useFormState();
  const [schoolCountry] = useState(values.schoolProfile.school?.country);

  return (
    <>
      <Field
        required
        fullWidth
        type="text"
        name="schoolProfile.school.name"
        label="School Name"
        placeholder="School Name"
        component={BootstrapInput}
      />
      <Field
        required
        disabled={!!schoolCountry}
        fullWidth
        name="schoolProfile.school.country"
        label="Country"
        options={countries}
        placeholder="Please Select"
        component={Autocomplete}
      />
      <Field
        disabled
        fullWidth
        type="text"
        name="schoolProfile.school.type"
        label="Education Type"
        options={EDUCATION_TYPES}
        placeholder="Please Select"
        component={Autocomplete}
      />
      <Field
        required
        fullWidth
        type="text"
        name="schoolProfile.school.website"
        label="School Website"
        placeholder="www.edu.uk"
        component={BootstrapInput}
      />
      <Field
        required
        fullWidth
        type="text"
        name="name"
        label="Representative Name"
        placeholder="John Smith"
        component={BootstrapInput}
      />
    </>
  );
}
